import { gql } from '@apollo/client';

const GET_BRANCH_URL = gql`
  query BranchUrl($collectionId: String!, $kic: String!) {
    branchUrl(collectionId: $collectionId, kic: $kic)
  }
`;

export default GET_BRANCH_URL;
